var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinalUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size=16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.26672 2.6666C2.26672 2.44569 2.44581 2.2666 2.66672 2.2666H13.3334C13.5543 2.2666 13.7334 2.44569 13.7334 2.6666C13.7334 2.88752 13.5543 3.0666 13.3334 3.0666H2.66672C2.44581 3.0666 2.26672 2.88752 2.26672 2.6666ZM7.71721 6.38376C7.87342 6.22755 8.12669 6.22755 8.2829 6.38376L10.9496 9.05043C11.1058 9.20664 11.1058 9.4599 10.9496 9.61611C10.7934 9.77232 10.5401 9.77232 10.3839 9.61611L8.40006 7.63229V13.3333C8.40006 13.5542 8.22097 13.7333 8.00006 13.7333C7.77914 13.7333 7.60006 13.5542 7.60006 13.3333V7.63229L5.61623 9.61611C5.46002 9.77232 5.20676 9.77232 5.05055 9.61611C4.89434 9.4599 4.89434 9.20664 5.05055 9.05043L7.71721 6.38376Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalUp);
export default __webpack_public_path__ + "static/media/final_up.a3e09f0f43adde070a5cbf17f488f364.svg";
export { ForwardRef as ReactComponent };